<lds-empty-state
  heading="Page not found"
  message="We are sorry, the page you requested does not exist or could not be found.">
</lds-empty-state>
